(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-core'.");
    }
    root['curity-ssi-libs-core'] = factory(typeof this['curity-ssi-libs-core'] === 'undefined' ? {} : this['curity-ssi-libs-core'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var contains = kotlin_kotlin.$_$.jc;
  var charSequenceSubSequence = kotlin_kotlin.$_$.y9;
  var equals = kotlin_kotlin.$_$.ba;
  var protoOf = kotlin_kotlin.$_$.kb;
  var equals_0 = kotlin_kotlin.$_$.pc;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.kf;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var toSet = kotlin_kotlin.$_$.r8;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var KtMap = kotlin_kotlin.$_$.r5;
  var VOID = kotlin_kotlin.$_$.f;
  var initMetadataForInterface = kotlin_kotlin.$_$.ma;
  var CoroutineImpl = kotlin_kotlin.$_$.n9;
  var SequenceScope = kotlin_kotlin.$_$.cc;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
  var initMetadataForLambda = kotlin_kotlin.$_$.na;
  var iterator = kotlin_kotlin.$_$.dc;
  var Iterable = kotlin_kotlin.$_$.m5;
  var Entry = kotlin_kotlin.$_$.q5;
  var listOf = kotlin_kotlin.$_$.n7;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var captureStack = kotlin_kotlin.$_$.t9;
  var Exception = kotlin_kotlin.$_$.ke;
  var joinToString = kotlin_kotlin.$_$.g7;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.m1;
  var toList = kotlin_kotlin.$_$.k8;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Locale, 'Locale');
  initMetadataForClass(Dictionary$toMap$1, VOID, VOID, VOID, [KtMap]);
  function toMap() {
    return new Dictionary$toMap$1(this);
  }
  initMetadataForInterface(Dictionary, 'Dictionary');
  initMetadataForLambda(MultiValue$_get_all_$o$iterator$slambda_sxfdxj, CoroutineImpl, VOID, [1]);
  function get_all() {
    return new MultiValue$all$1(this);
  }
  function isSingleItem() {
    return this.lm().s();
  }
  function forEach(action) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.qm().j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      action(element);
    }
  }
  initMetadataForInterface(MultiValue, 'MultiValue');
  initMetadataForClass(DefaultMultiValue, 'DefaultMultiValue', VOID, VOID, [MultiValue]);
  initMetadataForClass(MultiValue$all$1, VOID, VOID, VOID, [Iterable]);
  initMetadataForClass(MapDictionary, 'MapDictionary', VOID, VOID, [Dictionary]);
  initMetadataForInterface(ToString, 'ToString');
  initMetadataForClass(Entry_0, 'Entry', VOID, VOID, [Entry]);
  initMetadataForClass(Valid, 'Valid');
  initMetadataForClass(Invalid, 'Invalid');
  initMetadataForCompanion(Companion);
  initMetadataForClass(ValidationException, 'ValidationException', VOID, Exception);
  initMetadataForCoroutine($runCOROUTINE$0, CoroutineImpl);
  initMetadataForCompanion(Companion_0, VOID, VOID, [1]);
  initMetadataForClass(ValidationScope, 'ValidationScope', ValidationScope);
  //endregion
  function Locale(value) {
    this.pl_1 = value;
    this.ql_1 = (this.pl_1.length === 2 && !contains(this.pl_1, '-'));
    this.rl_1 = charSequenceSubSequence(this.pl_1, 0, 2);
  }
  protoOf(Locale).sl = function (other) {
    return equals(this.rl_1, other == null ? null : charSequenceSubSequence(other, 0, 2));
  };
  protoOf(Locale).equals = function (other) {
    var tmp;
    if (other instanceof Locale) {
      tmp = equals_0(other.pl_1, this.pl_1, true);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Locale).hashCode = function () {
    return getStringHashCode(this.pl_1);
  };
  protoOf(Locale).toString = function () {
    return this.pl_1;
  };
  function Dictionary$toMap$1(this$0) {
    this.ul_1 = this$0;
    this.tl_1 = this$0.f2();
  }
  protoOf(Dictionary$toMap$1).z = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.tl_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.data.<no name provided>.<get-entries>.<anonymous>' call
      var tmp$ret$0 = new Entry_0(item, ensureNotNull(this.vl(item)));
      destination.e(tmp$ret$0);
    }
    return toSet(destination);
  };
  protoOf(Dictionary$toMap$1).f2 = function () {
    return this.tl_1;
  };
  protoOf(Dictionary$toMap$1).m = function () {
    return this.tl_1.m();
  };
  protoOf(Dictionary$toMap$1).g2 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.tl_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.data.<no name provided>.<get-values>.<anonymous>' call
      var tmp$ret$0 = ensureNotNull(this.vl(item));
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(Dictionary$toMap$1).s = function () {
    return this.tl_1.s();
  };
  protoOf(Dictionary$toMap$1).vl = function (key) {
    return this.ul_1.vl(key);
  };
  protoOf(Dictionary$toMap$1).e2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.vl((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(Dictionary$toMap$1).wl = function (key) {
    return this.tl_1.a2(key);
  };
  protoOf(Dictionary$toMap$1).c2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.wl((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  function Dictionary() {
  }
  function MultiValue$_get_all_$o$iterator$slambda_sxfdxj(this$0, this$1, resultContinuation) {
    this.gm_1 = this$0;
    this.hm_1 = this$1;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).jm = function ($this$iterator, $completion) {
    var tmp = this.km($this$iterator, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).y9 = function (p1, $completion) {
    return this.jm(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 5;
            this.v8_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.v8_1 = 6;
              continue $sm;
            }

            if (this.gm_1.nm_1) {
              this.v8_1 = 3;
              suspendResult = this.im_1.cf(this.hm_1.mm(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 2;
              suspendResult = this.im_1.ef(this.hm_1.lm(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.v8_1 = 6;
            continue $sm;
          case 3:
            this.gm_1.nm_1 = false;
            this.v8_1 = 4;
            continue $sm;
          case 4:
            this.v8_1 = 1;
            continue $sm;
          case 5:
            throw this.y8_1;
          case 6:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 5) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).km = function ($this$iterator, completion) {
    var i = new MultiValue$_get_all_$o$iterator$slambda_sxfdxj(this.gm_1, this.hm_1, completion);
    i.im_1 = $this$iterator;
    return i;
  };
  function MultiValue$_get_all_$o$iterator$slambda_sxfdxj_0(this$0, this$1, resultContinuation) {
    var i = new MultiValue$_get_all_$o$iterator$slambda_sxfdxj(this$0, this$1, resultContinuation);
    var l = function ($this$iterator, $completion) {
      return i.jm($this$iterator, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DefaultMultiValue(elements) {
    this.pm_1 = elements;
  }
  protoOf(DefaultMultiValue).mm = function () {
    return this.pm_1.o(0);
  };
  protoOf(DefaultMultiValue).lm = function () {
    return this.pm_1.v(1, this.pm_1.m());
  };
  protoOf(DefaultMultiValue).qm = function () {
    return this.pm_1;
  };
  function MultiValue$all$1(this$0) {
    this.om_1 = this$0;
    this.nm_1 = true;
  }
  protoOf(MultiValue$all$1).j = function () {
    return iterator(MultiValue$_get_all_$o$iterator$slambda_sxfdxj_0(this, this.om_1, null));
  };
  function MultiValue() {
  }
  function MapDictionary(map) {
    this.tm_1 = map;
  }
  protoOf(MapDictionary).f2 = function () {
    return this.tm_1.f2();
  };
  protoOf(MapDictionary).vl = function (key) {
    return this.tm_1.e2(key);
  };
  protoOf(MapDictionary).xl = function () {
    return this.tm_1;
  };
  function ToString() {
  }
  function Entry_0(key, value) {
    this.um_1 = key;
    this.vm_1 = value;
  }
  protoOf(Entry_0).a1 = function () {
    return this.um_1;
  };
  protoOf(Entry_0).b1 = function () {
    return this.vm_1;
  };
  function Valid(value) {
    this.wm_1 = value;
  }
  protoOf(Valid).xm = function () {
    return this.wm_1;
  };
  function Invalid(errors) {
    this.ym_1 = errors;
  }
  protoOf(Invalid).xm = function () {
    throw new ValidationException(this.ym_1);
  };
  function Companion() {
  }
  protoOf(Companion).zm = function (error) {
    return new Invalid(listOf(error));
  };
  protoOf(Companion).an = function (value) {
    return new Valid(value);
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function ValidationException_init_$Init$(error, $this) {
    ValidationException.call($this, listOf(error));
    return $this;
  }
  function ValidationException_init_$Create$(error) {
    var tmp = ValidationException_init_$Init$(error, objectCreate(protoOf(ValidationException)));
    captureStack(tmp, ValidationException_init_$Create$);
    return tmp;
  }
  function ValidationException(errors) {
    Exception_init_$Init$('validation error: ' + joinToString(errors, '\n'), this);
    captureStack(this, ValidationException);
    this.bn_1 = errors;
  }
  function suspendableValidationScope(block, $completion) {
    return Companion_instance_0.cn(block, $completion);
  }
  function $runCOROUTINE$0(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ln_1 = _this__u8e3s4;
    this.mn_1 = block;
  }
  protoOf($runCOROUTINE$0).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.nn_1 = new ValidationScope();
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.mn_1(this.nn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.on_1 = suspendResult;
            this.w8_1 = 3;
            this.v8_1 = 4;
            continue $sm;
          case 2:
            this.w8_1 = 3;
            var tmp_0 = this.y8_1;
            if (tmp_0 instanceof Exception) {
              var ex = this.y8_1;
              var tmp_1 = this;
              var tmp0_elvis_lhs = ex.message;
              this.nn_1.pn_1.e(tmp0_elvis_lhs == null ? 'Unknown error' : tmp0_elvis_lhs);
              return new Invalid(toList(this.nn_1.pn_1));
            } else {
              throw this.y8_1;
            }

          case 3:
            throw this.y8_1;
          case 4:
            this.w8_1 = 3;
            var res = this.on_1;
            var tmp_2;
            if (!this.nn_1.pn_1.s()) {
              tmp_2 = new Invalid(toList(this.nn_1.pn_1));
            } else {
              var tmp_3;
              if (res == null) {
                tmp_3 = Companion_instance.zm('Unknown error');
              } else {
                tmp_3 = new Valid(res);
              }
              tmp_2 = tmp_3;
            }

            return tmp_2;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function Companion_0() {
  }
  protoOf(Companion_0).cn = function (block, $completion) {
    var tmp = new $runCOROUTINE$0(this, block, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function ValidationScope() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.pn_1 = ArrayList_init_$Create$_0();
    this.qn_1 = this.pn_1.s();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_0.rn_1 = !this.pn_1.s();
  }
  protoOf(ValidationScope).sn = function (msg, predicate) {
    if (!predicate()) {
      this.pn_1.e(msg);
    }
  };
  protoOf(ValidationScope).tn = function (msg, value, applyOnExisting) {
    if (value == null) {
      this.pn_1.e(msg);
    } else {
      applyOnExisting(value);
    }
  };
  protoOf(ValidationScope).un = function (name, value, block) {
    var tmp;
    if (value == null) {
      this.vn("Missing claim '" + name + "'");
      tmp = null;
    } else if (!(block == null)) {
      tmp = block(this, value);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(ValidationScope).wn = function (value, block) {
    if (!(value == null)) {
      block(value);
    }
  };
  protoOf(ValidationScope).xn = function (msg, value, converter) {
    var tmp;
    try {
      tmp = converter(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        this.vn(msg(e));
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ValidationScope).vn = function (msg) {
    this.pn_1.e(msg);
  };
  //region block: post-declaration
  protoOf(DefaultMultiValue).rm = forEach;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = suspendableValidationScope;
  _.$_$.b = ValidationException_init_$Create$;
  _.$_$.c = Companion_instance;
  _.$_$.d = toMap;
  _.$_$.e = Dictionary;
  _.$_$.f = Locale;
  _.$_$.g = MapDictionary;
  _.$_$.h = DefaultMultiValue;
  _.$_$.i = get_all;
  _.$_$.j = forEach;
  _.$_$.k = isSingleItem;
  _.$_$.l = MultiValue;
  _.$_$.m = ToString;
  _.$_$.n = ValidationScope;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-core.js.map
